// extracted by mini-css-extract-plugin
export default {"products":"Xv-z","card":"Yv-z","oosMessaging":"Zv-z"};